import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useStoreByName } from '@web/hooks/use-stores.hooks';
import { useBookContent } from '../../../hooks/useBooksQuery';
import { IBook } from '@shared/types';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const styles = {
  formControl: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      backgroundColor: '#fff',
    },
    '& .MuiSelect-select': {
      padding: '8px 10px',
    }
  }
};

/** The Siddur has its own reader, so picking it here goes there. */
const SIDDUR = 'Siddur_Ashkenaz';

const BookSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {books, setSelectedBook, selectedBook} = useStoreByName('booksStore');
  
  // TanStack Query hook for book content - handles caching automatically
  // This will sync data to MobX store when book changes
  useBookContent(selectedBook?.name_en || '');

  return (
    <FormControl sx={styles.formControl} data-tour="book-selector">
      <InputLabel>{t("book")}</InputLabel>
      <Select
        value={selectedBook?.name_en ?? books[0]?.name_en}
        label={t("book")}
        inputProps={{ 'aria-label': t("book") }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          PaperProps: {
            sx: {
              marginTop: '4px',
              maxHeight: '300px'
            }
          }
        }}
        onChange={(event) => {
          const selected = books.find((book: IBook) => book.name_en === event.target.value);
          // The Siddur is read through /siddur now: a tree of gates, parts and
          // prayers rather than five dropdowns. Sending it down the level
          // selectors would be sending it back to the interface it replaced.
          // Where the reader is switched off the Siddur is not in `books` at all.
          if (selected?.name_en === SIDDUR) {
            navigate('/siddur');
            return;
          }
          setSelectedBook(selected as IBook);
        }}
      >
        {books.map((book: IBook) => (
          <MenuItem key={book.name_en} value={book.name_en}>
            {book.name_he}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default observer(BookSelector);
